import { useEffect, useState } from "react";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import UiRangeSlider from "../common/UiRangeSlider";
import { useSelector } from "react-redux";

const FilterClients = ({ data, fields, setValue, alldata, setItems }) => {
  const [formFields, setFields] = useState({ ...fields });

  const mobile = useSelector((state) => state.mobile);
  const minSumDeals = alldata ? Math.min(...alldata.map((item) => item.amount)) : 0;
  const maxSumDeals = alldata ? Math.max(...alldata.map((item) => item.amount)) : 0;
  const minCommission = alldata ? Math.min(...alldata.map((item) => item.commission)) : 0;
  const maxCommission = alldata ? Math.max(...alldata.map((item) => item.commission)) : 0;
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    if (data && (fields.manager.value || fields.broker.value || fields.projectId.value || fields.typeId.value || fields.search.value || fields.amount.value || fields.commission.value)) filtrate();
  }, [fields]);

  const realty = useSelector((state) => state.realty);

  const filtrate = () => {
    const filteredData = alldata.filter((el) => {
      return (
        (!fields.manager.value || el.manager === fields.manager.value.label) &&
        (!fields.broker.value || el.broker === fields.broker.value.label) &&
        (!fields.projectId.value || el.projectId === fields.projectId.value.label) &&
        (!fields.typeId.value || el.typeId === fields.typeID.value.label) &&
        (!fields.search.value || Object.values(el).filter((item) => typeof item == "string" && item.toLowerCase().indexOf(fields.search.value.toLowerCase()) > -1).length) &&
        (!fields.amount.value || (el.amount >= fields.amount.value[0] && el.amount <= fields.amount.value[1])) &&
        (!fields.commission.value || (el.commission >= fields.commission.value[0] && el.commission <= fields.commission.value[1]))
      );
    });

    setItems(filteredData.length > 0 ? filteredData : null);
  };

  const changeValue = (name, value) => {
    setValue({ ...fields, [name]: { ...fields[name], value } });
  };

  const clearFilter = () => {
    setValue({ ...formFields });
    setItems(null);
  };

  return (
    <div className="filter-block">
      <div>
        <div className="filter-block__column">          
            {auth.user.group != "lead" && (<div>
              <Select
                className="select"
                classNamePrefix="select"
                placeholder={"Менеджер"}
                value={fields.manager.value}
                isSearchable={false}
                components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
                }}
                defaultValue={null}
                onChange={(val) => changeValue("manager", val)}
                options={data ? data.map((item) => ({ value: item.managerId, label: item.manager })).filter((obj, idx, arr) => idx === arr.findIndex((t) => t.value === obj.value)) : []}
              />
            </div>)}          
          {auth.user.group === "lead" && <div className="filter-block__row">
            <Select
                className="select"
                classNamePrefix="select"
                placeholder={"Менеджер"}
                value={fields.manager.value}
                isSearchable={false}
                components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
                }}
                defaultValue={null}
                onChange={(val) => changeValue("manager", val)}
                options={data ? data.map((item) => ({ value: item.managerId, label: item.manager })).filter((obj, idx, arr) => idx === arr.findIndex((t) => t.value === obj.value)) : []}
              />
              <Select
                  className="select"
                  classNamePrefix="select"
                  placeholder={"Брокер"}
                  value={fields.broker.value}
                  isSearchable={false}
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                  }}
                  defaultValue={null}
                  onChange={(val) => changeValue("broker", val)}
                  options={data ? data.map((item) => ({ value: item.brocker, label: item.brocker })).filter((obj, idx, arr) => idx === arr.findIndex((t) => t.value === obj.value)) : []}
                />
            </div>}
          <div className="filter-block__row">
            <UiRangeSlider
              placeholder={"Сумма сделки"}
              min={minSumDeals}
              max={maxSumDeals}
              values={fields.amount.value.length != 0 ? fields.amount.value : [minSumDeals, maxSumDeals]}
              onChange={(val) => changeValue("amount", val)}
              name="amount"
            />
            <UiRangeSlider
              placeholder={"Комиссия"}
              min={minCommission}
              max={maxCommission}
              values={fields.commission.value.length != 0 ? fields.commission.value : [minCommission, maxCommission]}
              onChange={(val) => changeValue("commission", val)}
              name="commission"
            />
          </div>
        </div>
        <div className="filter-block__column">
          <div>
            <div className="filter-block__row">
              <Select
                className="select"
                classNamePrefix="select"
                placeholder={"Выберите проект"}
                value={fields.projectId.value}
                isSearchable={false}
                components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
                }}
                defaultValue={null}
                onChange={(val) => changeValue("projectId", val)}
                options={
                  data
                    ? data
                        .map((item) => ({ value: item?.projectId, label: realty?.projects?.find((p) => p.id === item?.projectId)?.name }))
                        ?.filter((obj, idx, arr) => idx === arr?.findIndex((t) => t.value === obj.value))
                    : []
                }
              />
              {!mobile && (<div className="form__search">
                <input value={fields.search.value} type="text" className="form__input" placeholder={"Поиск по таблице"} onChange={(e) => changeValue("search", e.target.value)} autoComplete="off" />
              </div>)}
            </div>
          </div>
          <Select
            className="select"
            classNamePrefix="select"
            placeholder={"Тип объекта"}
            value={fields.typeId.value}
            isSearchable={false}
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
            }}
            defaultValue={null}
            onChange={(val) => changeValue("typeId", val)}
            options={
              data
                ? data
                    .map((item) => ({ value: item?.typeId, label: realty?.types?.find((p) => p.id === item?.typeId)?.name }))
                    ?.filter((obj, idx, arr) => idx === arr.findIndex((t) => t.value === obj?.value))
                : []
            }
          />
          {mobile && (<div className="form__search">
            <input value={fields.search.value} type="text" className="form__input" placeholder={"Поиск по таблице"} onChange={(e) => changeValue("search", e.target.value)} autoComplete="off" />
          </div>)}
        </div>
      </div>
      <div>
        <button type="button" className="btn btn_empty btn_small" onClick={clearFilter}>
          Очистить фильтр
        </button>
      </div>
    </div>
  );
};

export default FilterClients;
